export default "__VITE_ASSET__CS$WDFEb__"